import React, { Component } from 'react';
import Api                  from '../../Utils/api';
import Parse                from 'parse';
import Utils                from '../../Utils/Utility';
import payment              from '../../lib/jquery.payment';
import SpinButton           from '../../components/generic/spin-button';
import classNames           from 'classnames/bind';

export default class AddBankAccount extends Component {

    constructor(props) {
        super(props);
        this.state = {
            accountHolderName    : '',
            routingNumber        : '',
            accountNumber        : '',
            reAccountNumber      : '',
            acctNumMisMatch      : false,
            routingNumberError   : false,
            accountNumberError   : false,
            reAccountNumberError : false,
            isBankAccCreated     : false,
            showSpinner          : false
        };
    }

    changeAccountHolderName = (e) => {
        this.setState({ accountHolderName : e.target.value });
    }

    changeRoutingNumber = (e) => {
        const routingNumber = e.target.value;
        const result        = Stripe.bankAccount.validateRoutingNumber(routingNumber , 'US') // US routing number
        if (result) {
            this.setState({routingNumber, routingNumberError : false});
        } else {
            this.setState({routingNumber, routingNumberError : true});
        }
    }

    changeAccountNumber = (e) => {
        const accountNumber = e.target.value;
        const result        = Stripe.bankAccount.validateAccountNumber(accountNumber, 'US');

        if (result) {
            this.setState({ accountNumber, accountNumberError : false });
        } else {
            this.setState({ accountNumber, accountNumberError : true});
        }
    }

    changeReAccountNumber = (e) => {
        const reAccountNumber = e.target.value;
        const result = Stripe.bankAccount.validateAccountNumber(reAccountNumber, 'US');
        if (result) {
            if ( this.state.accountNumber !== reAccountNumber ) {
                this.setState({ reAccountNumber, acctNumMisMatch : true });
            } else {
                this.setState({ reAccountNumber, acctNumMisMatch : false });
            }
        } else {
            this.setState({ reAccountNumber, reAccountNumberError : true, acctNumMisMatch : false});
        }
    }

    initializeCustomerDetails = () => {
        const currentUser = Parse.User.current();
        return {
            firstName          : currentUser.get("firstName"),
            lastName           : currentUser.get("lastName"),
            name               : currentUser.get("name"),
            email              : currentUser.get("email"),
            phone              : currentUser.get("phoneNumber"),
        };
    }

    componentDidMount() {

        // console.log("PARSE_SP_KEY:" + PARSE_SP_KEY);
        Stripe.setPublishableKey(PARSE_SP_KEY);

    }


    createStripeBankCustomer = (e) => {
        e.preventDefault();
        const self = this;

        this.setState({
            bankAccountError    : false,
            bankAccountErrorMsg : '',
            showSpinner         : true
        });

        /* Create token */
        const bankData = {
            country             : "US",
            currency            : "USD",
            routing_number      : this.state.routingNumber,
            account_number      : this.state.accountNumber,
            account_holder_name : this.state.accountHolderName,
            account_holder_type : "company"
        };

        Stripe.bankAccount.createToken(bankData, function stripeResponseHandler(status, response) {
            if (response.error) {
                self.setState({
                    bankAccountError    : true,
                    bankAccountErrorMsg : response.error.message,
                    showSpinner         : false
                });
            } else {
                const token           = response.id;
                const userDetailPtrId = Parse.User.current().id;
                const sessionToken    = Parse.User.current().getSessionToken();
                const customerId      = (self.state.customerId) || "";
                let customerDetails   = self.initializeCustomerDetails();
                let locId = self.props.locId;

                Api.createBankCustomerOnStripe
                (locId, userDetailPtrId, sessionToken, customerId, customerDetails, token)
                    .then(
                        (res) => {
                            self.setState({
                                bankAccountError    : false,
                                bankAccountErrorMsg : "",
                                isBankAccCreated    : true,
                                showSpinner         : false
                            }, self.props.callbackParent());
                        },
                        (errorRes) => {
                            if (errorRes && errorRes.responseJSON) {
                                self.setState({
                                    bankAccountError    : true,
                                    bankAccountErrorMsg : errorRes.responseJSON.error.message,
                                    showSpinner         : false
                                });
                            }
                        });
            }
        });
    }


    render() {

        let acctNumMatchError  = this.state.accountNumber !== this.state.reAccountNumber ? "has-error has-feedback" : "";

        const addBankAccount = (
            <div className="col-md-12">
                <br/>
                <h2 className="text-center">Bank details</h2>
                <br/>

                {
                    this.state.bankAccountError
                        ? (
                            <div className = "alert alert-danger" role = "alert">
                                {this.state.bankAccountErrorMsg}
                            </div>
                        )
                        : null
                }

                <form id="bank-form" autoComplete="on" onSubmit={this.createStripeBankCustomer}>
                    <fieldset>
                        <div className="form-group">
                            <div className="col-xs-12">
                                <label
                                    htmlFor   = "accountHolderName"
                                    className = "control-label"
                                >
                                    Account Holder Name
                                </label>
                                <input
                                    id          = "accountHolderName"
                                    type        = "text"
                                    placeholder = "Account holder name"
                                    onChange    = {this.changeAccountHolderName}
                                    value       = {this.state.accountHolderName}
                                    className   = "form-control"
                                    required
                                    autoFocus
                                />
                            </div>
                          </div>

                        <div className="form-group">
                            <div className="col-xs-12">
                                <label htmlFor="routNum" className="control-label">Routing Number</label>
                                <input
                                    id          = "routNum"
                                    type        = "text"
                                    placeholder = "Routing Number"
                                    onChange    = {this.changeRoutingNumber}
                                    value       = {this.state.routingNumber}
                                    className   = "form-control"
                                    required
                                    autoFocus
                                />
                            </div>
                        </div>

                        <br/>
                        {
                            this.state.routingNumberError
                                ? <div className="alert alert-danger" role="alert">Incorret routing number!</div>
                                : null
                        }

                        <div className="form-group">
                              <div className="col-xs-12">
                                <label htmlFor="acctNum" className="control-label">Account Number</label>
                                <input
                                    id          = "acctNum"
                                    type        = "text"
                                    placeholder = "Bank account number"
                                    onChange    = {this.changeAccountNumber}
                                    value       = {this.state.accountNumber}
                                    className   = "form-control"
                                    required
                                    autoFocus
                                />
                            </div>
                        </div>

                        <br/>
                        {
                            this.state.accountNumberError
                                ? <div className="alert alert-danger" role="alert">Incorret account number!</div>
                                : null
                        }

                        <div className="form-group">
                            <div className="col-xs-12">
                                <label htmlFor="resCity" className="control-label">Re-account Number</label>
                                <input
                                    id          = "resAcctNum"
                                    type        = "text"
                                    placeholder = "Confirm bank account number"
                                    title       = "Re Account Number"
                                    onChange    = {this.changeReAccountNumber}
                                    value       = {this.state.reAccountNumber}
                                    className   = "form-control"
                                    required
                                    autoFocus
                                />
                                <br/>
                                {
                                    this.state.acctNumMisMatch
                                        ? <div className="alert alert-danger" role="alert">Account number does not match!</div>
                                        : null
                                }
                                {
                                    this.state.reAccountNumberError
                                        ? <div className="alert alert-danger" role="alert">Incorret account number!</div>
                                        : null
                                }
                            </div>
                        </div>

                        <div className="col-xs-12">

                            <SpinButton
                                classNames  = "payment btn btn-lg btn-block btn-primary"
                                buttonText  = "Save"
                                spinText    = "Adding bank details..."
                                showSpinner = {this.state.showSpinner}
                                inputType   = "submit"
                            />

                        </div>
                          <div className="row" style={{'display':'none'}}>
                              <div className="col-xs-12">
                                  <p className="payment-errors"></p>
                              </div>
                          </div>
                          <h2 className="validation"></h2>
                    </fieldset>
                </form>
            </div>
        );
        return  addBankAccount;
    }
}



// WEBPACK FOOTER //
// src/components/payment/add-bank-account.js